import Service from './service'
export var ApiPrintMessageType;
(function (ApiPrintMessageType) {
  ApiPrintMessageType["PRINT_LOW_PAPER"] = "printer.paper.low"
  ApiPrintMessageType["PRINT_SUCCESS"] = "printer.success"
  ApiPrintMessageType["PRINT_STATE_INFO"] = "printer.state.info"
  ApiPrintMessageType["PRINT_ERROR"] = "printer.error"
  ApiPrintMessageType["PRINT_NO_PAPER"] = "printer.nopaper"
  ApiPrintMessageType["PRINT_NO_PRINTER"] = "printer.noprinter"
  ApiPrintMessageType["PRINT"] = "printer.print"
  ApiPrintMessageType["PRINT_STATE"] = "printer.state"
})(ApiPrintMessageType || (ApiPrintMessageType = {}))
export var PrintMessageType;
(function (PrintMessageType) {
  PrintMessageType["PRINTER_SUCCESS"] = "PRINTER_SUCCESS"
  PrintMessageType["PRINTER_ERROR"] = "PRINTER_ERROR"
  PrintMessageType["PRINTER_INFO"] = "PRINTER_INFO"
  PrintMessageType["PRINTER_LOW_PAPER"] = "PRINTER_LOW_PAPER"
  PrintMessageType["PRINTER_NO_PAPER"] = "PRINTER_NO_PAPER"
  PrintMessageType["PRINTER_NO_PRINTER"] = "PRINTER_NO_PRINTER"
})(PrintMessageType || (PrintMessageType = {}))
/**
 * Сервис для печати на чековом принтере
 * @version 0.0.1
 * @since 1.8.0
 */
export default class PrinterService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiPrintMessageType.PRINT_SUCCESS:
          this.resolve(this.waiters.result)
          this.broadcast(PrintMessageType.PRINTER_SUCCESS)
          break
        case ApiPrintMessageType.PRINT_STATE_INFO:
          this.resolve(this.waiters.status, message.state)
          this.broadcast(PrintMessageType.PRINTER_INFO, message)
          break
        case ApiPrintMessageType.PRINT_NO_PAPER:
          this.broadcast(PrintMessageType.PRINTER_NO_PAPER)
          this.reject(this.waiters.result, message.type)
          break
        case ApiPrintMessageType.PRINT_LOW_PAPER:
          this.broadcast(PrintMessageType.PRINTER_LOW_PAPER, message)
          break
        case ApiPrintMessageType.PRINT_NO_PRINTER:
          this.broadcast(PrintMessageType.PRINTER_NO_PRINTER)
          this.reject(this.waiters.result, message.type)
          break
        case ApiPrintMessageType.PRINT_ERROR:
          this.broadcast(PrintMessageType.PRINTER_ERROR, message.type)
          this.reject(this.waiters.result, message.type)
          break
      }
    }
    this.waiters = {
      result: [],
      status: [],
    }
    this.messageChannel.subscribe(ApiPrintMessageType.PRINT_STATE_INFO, messageHandler)
    this.messageChannel.subscribe(ApiPrintMessageType.PRINT_ERROR, messageHandler)
    this.messageChannel.subscribe(ApiPrintMessageType.PRINT_LOW_PAPER, messageHandler)
    this.messageChannel.subscribe(ApiPrintMessageType.PRINT_NO_PAPER, messageHandler)
    this.messageChannel.subscribe(ApiPrintMessageType.PRINT_NO_PRINTER, messageHandler)
    this.messageChannel.subscribe(ApiPrintMessageType.PRINT_SUCCESS, messageHandler)
  }
  /**
     * Напечатать фотографию или документ
     *
     * @since 1.8.0
     * @param {string} data - данные для печати
     * @param {('image/png' | 'text/html')} mimeType - mimeType данных содержащихся в поле data
     * допустимые варианты mimeType:
     *
     * image/png для картинок
     *
     * text/html для текстовых документов в т.ч. html
     *
     * {@link https://doc.qt.io/qt-5/richtext-html-subset.html|Supported HTML Subset}
     *
     * @return {*}
     * @memberof PrinterService
     *
     * @example <caption>Напечатать фото</caption>
     * robot.printService.print(data, mimeType)
     */
  print(data, mimeType) {
    return this.execute({
      type: ApiPrintMessageType.PRINT,
      mime_type: mimeType,
      data,
      ignoreNotConnected: true,
    }, this.waiters.result)
  }
  /**
     * Получить статус чекового принтера
     *
     * @since 1.8.0
     * @return {*}
     * @memberof PrinterService
     *
     * @example <caption>Получить статус чекового принтера</caption>
     * robot.printService.status()
     */
  status() {
    return this.execute({
      type: ApiPrintMessageType.PRINT_STATE,
      ignoreNotConnected: true,
    }, this.waiters.status)
  }
  /**
     * Данные успешно отправлены на печать
     *
     * @since 1.8.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PrinterService
     *
     * @example <caption>Данные успешно отправлены на печать</caption>
     * robot.printService.onSuccess(() => {
     *   ...
     * })
     */
  onSuccess(callback) {
    return this.subscribe(PrintMessageType.PRINTER_SUCCESS, callback)
  }
  /**
     * Произошла ошибка печати
     *
     * @since 1.8.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PrinterService
     *
     * @example <caption>Произошла ошибка печати</caption>
     * robot.printService.onError(() => {
     *   ...
     * })
     */
  onError(callback) {
    return this.subscribe(PrintMessageType.PRINTER_ERROR, callback)
  }
  /**
     * Сервис вернул данные о состоянии чекового принтера
     *
     * @since 1.8.0
     * @param {(data: PrinterStatusData) => void} callback
     * Варианты статуса:
     * IDLE - чековый принтер готов к работе
     * NOT_CONNECTED - отсутствует подключение к чековому принтеру
     * IN_PROCESS - идёт процесс печати
     * (статусы ошибки имеют дополнительные поля error_code и error_message)
     * LOW_PAPER - ошибка - мало бумаги (предупреждение, печать возможна)
     * NO_PAPER - ошибка - нет бумаги
     * ERROR - иная ошибка
     *
     * @return {*}  {UnsubscribeFunction}
     * @memberof PrinterService
     *
     * @example <caption>Сервис вернул данные о состоянии чекового принтера</caption>
     * robot.printService.onInfo((data) => {
     *   console.log(data.state)
     * })
     */
  onInfo(callback) {
    return this.subscribe(PrintMessageType.PRINTER_INFO, callback)
  }
  /**
     * Мало бумаги (предупреждение, печать возможна)
     *
     * @since 1.8.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PrinterService
     *
     * @example <caption>Мало бумаги</caption>
     * robot.printService.onLowPaper(() => {
     *   ...
     * })
     */
  onLowPaper(callback) {
    return this.subscribe(PrintMessageType.PRINTER_LOW_PAPER, callback)
  }
  /**
     * Закончилась бумага
     *
     * @since 1.8.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PrinterService
     *
     * @example <caption>Закончилась бумага</caption>
     * robot.printService.onNoPaper(() => {
     *   ...
     * })
     */
  onNoPaper(callback) {
    return this.subscribe(PrintMessageType.PRINTER_NO_PAPER, callback)
  }
  /**
     * Чековый принтер отсутствует
     *
     * @since 1.8.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PrinterService
     *
     * @example <caption>Чековый принтер отсутствует</caption>
     * robot.printService.onNoPrinter(() => {
     *   ...
     * })
     */
  onNoPrinter(callback) {
    return this.subscribe(PrintMessageType.PRINTER_NO_PRINTER, callback)
  }
}
